<template>
  <div>
    <resumen-dominio
      class="terminal-resumen"
      mensaje=""
      v-bind:response="response"
      @addToList="addToList"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);
export default {
  created : async  function (){
    if (this.posicion === "none")
      this.posicion = "";
    else if(this.posicion === undefined)
      this.posicion = "top";
    this.registerLabel = (this.registerLabel === undefined) ? 'Agregar'  : 'Registrar';

  },
  components:{
        ResumenDominio: () => import ('@/components/DominioResumenComponent')
     },
  computed: {
    ...mapGetters([
        'active',
        'getdomain',
        'getzone',
        'getzoneid'
    ]),
        domainToFind : {
           get () {
               return this.$store.state.domain;
           } 
        },
        valordominio : function(){
             return (this.disponibilidadDominios.simbolo) + ''+(this.disponibilidadDominios.precio).toFixed(2) + '/año';
        }
    },
    watch: {
        domainToFind(newValue) {
            this.dominioModel.dominio = newValue;
            this.availabledomains(newValue);
        }
    },
    data: () => ({
        title:'CONSULTA WHOIS',
        dominioModel  : {
            dominio : '',
            zona : '',
            idZona : 0
        },
      err: false,
      errorMsg:'',
        response : 0,
        dominio : {
            dominio : '',
            zona : '',
            idZona : 0,
            precio : 0,
            simbolo : ''
        },
        disponibilidadDominios : {

        },
        dominiosSugeridos : [

        ],
            tokenOP : '',
      items:[
          {
              'text':'dominio.com.ni', 
               icon:'mdi-checkbox-marked-circle',
              'subtitle':'$50.00/año',
              'color':'#7CC609'
          }
      ],
    }),
    methods: {
      addToList(newDomain) {
        this.$emit('addToList', newDomain);
      },
      toasterMessageResponse : function (msg, type){
        Vue.$toast.open({
          message: msg,
          type: type,
        });
      },
      compradominiostore : function(){
          localStorage.setItem(btoa('dominio'), btoa(JSON.stringify(this.disponibilidadDominios)));
      },
      selectedDomain : function(domain,currency, amount){
          this.$store.commit('domainToPurchase', domain);
          this.$store.commit('domainCurrency', currency);
          this.$store.commit('domainPrice', amount);
      },
      valordominiosugerido : function(moneda, valor){
              return ((moneda == 'Dólar') ? '$' : 'C$') + ''+(valor).toFixed(2) + '/año';
      },
      availabledomains : async function() {
      this.registerLabel = (this.registerLabel === undefined) ? 'Agregar'  : 'Registrar';

      await this.$http.get(this.$keys('DISPONIBILIDAD_DOMINIO') +'?dominio='+this.dominioModel.dominio+'&zona=' + this.getzone+'&idZona='+this.getzoneid).
        then((response) => {
        if (response.status === 200 ) {
          let array = []
          localStorage.setItem('localdomain', array);
          this.err = false;
            if(response.data.disponibilidadDominios){
              this.response  = 500;
                this.disponibilidadDominios =  response.data.disponibilidadDominios[0];
                this.dominiosSugeridos = response.data.disponibilidadDominios.filter( x => x.sugerido === true);
                this.tokenOP = response.data.tokenOP;
                this.addDomainToList(this.disponibilidadDominios);
            }
        }
      }).catch(error => {
        if (error.response == 409){
          this.err = true;
          this.toasterMessageResponse(error.response.data.mensaje, 'error');
        }
      });
      }
    }
}
</script>

<style scoped>
/* Estilo terminal para el contenedor principal */
.terminal-resumen {
  background-color: #000;
  color: #00ff00;
  font-family: 'Courier New', monospace;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #333;
  margin-top: 20px;
  min-height: 400px;
}

/* Encabezado del terminal */
.terminal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #222;
  padding: 10px 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 1px solid #444;
}

.terminal-title {
  color: #00ff00;
  font-weight: bold;
  font-size: 16px;
}

.terminal-subtitle {
  color: #aaa;
  font-size: 12px;
}

/* Contenido del terminal */
.terminal-content {
  padding: 15px;
}

/* Línea de comandos */
.command-line {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.prompt {
  color: #00ff00;
  margin-right: 10px;
  font-weight: bold;
}

.command {
  color: #fff;
}

.cursor {
  color: #00ff00;
  animation: blink 1s infinite;
  margin-left: 5px;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

/* Resultados */
.domain-result {
  margin-top: 20px;
  padding: 15px;
  background-color: #111;
  border: 1px solid #333;
  border-radius: 3px;
}

.available-domain {
  color: #7CC609;
}

.domain-name {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}

.domain-price {
  color: #00ff00;
  font-size: 14px;
  margin-left: 10px;
}

/* Dominios sugeridos */
.suggested-domains {
  margin-top: 20px;
}

.suggested-title {
  color: #aaa;
  font-size: 14px;
  margin-bottom: 10px;
}

.suggested-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.suggested-item {
  background-color: #222;
  padding: 8px 12px;
  border: 1px solid #444;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.3s;
}

.suggested-item:hover {
  background-color: #333;
  border-color: #00ff00;
}

/* Botones en estilo terminal */
.terminal-button {
  background-color: #222 !important;
  border: 1px solid #00ff00 !important;
  border-radius: 0 !important;
  color: #00ff00 !important;
  font-family: 'Courier New', monospace !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}

.terminal-button:hover {
  background-color: #00ff00 !important;
  color: #000 !important;
}

/* Status bar */
.terminal-status {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px dashed #444;
  font-size: 12px;
  color: #888;
}

/* Responsive */
@media (max-width: 960px) {
  .terminal-resumen {
    padding: 15px;
    margin-top: 15px;
  }
  
  .terminal-status {
    flex-direction: column;
    gap: 5px;
  }
}

@media (max-width: 600px) {
  .terminal-resumen {
    padding: 10px;
  }
  
  .command-line {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .prompt {
    margin-bottom: 5px;
  }
}

/* Efecto de scanlines sutil */
.terminal-content {
  position: relative;
}

.terminal-content::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    transparent 50%,
    rgba(0, 255, 0, 0.01) 50%
  );
  background-size: 100% 3px;
  pointer-events: none;
  z-index: 1;
}

/* Override de estilos Vuetify para terminal */
:deep(.v-application .primary) {
  background-color: #222 !important;
  border-color: #00ff00 !important;
}

:deep(.v-application .primary--text) {
  color: #00ff00 !important;
}

:deep(.v-chip) {
  background-color: #222 !important;
  color: #00ff00 !important;
  border: 1px solid #444 !important;
}

:deep(.v-chip .v-icon) {
  color: #7CC609 !important;
}

:deep(.v-list-item__title) {
  color: #00ff00 !important;
  font-family: 'Courier New', monospace !important;
}

:deep(.v-list-item__subtitle) {
  color: #7CC609 !important;
  font-family: 'Courier New', monospace !important;
}
</style>